// dependencies
import React from "react";
import { useIntl } from "react-intl";
import { StyleSheet } from "react-native";

// components
import Heading from "../Heading";
import Text from "../Text";
import Stack from "../Stack";

// constants
import { HOTEL_HANDICAP_INTL_MESSAGES } from "@cloudspire/shared/constants/hotel";

// utils
import intlFormatConstantByValue from "@cloudspire/shared/utils/intl/formatConstantByValue";

type PropsType = {
  handicapList: ReturnType<
    typeof import("../../normalizers/room/parseRoomData").default
  >["handicapList"];
};

const styles = StyleSheet.create({
  heading: {
    color: "#3a485f",
    fontWeight: "500",
  },
});

const RoomHandicapList: React.FunctionComponent<PropsType> = (props) => {
  const { handicapList } = props;

  const intl = useIntl();

  return (
    <>
      <Heading level={3} size="1.625em" style={styles.heading}>
        {intl.formatMessage({
          defaultMessage: "Accessibilité",
        })}
      </Heading>
      <Stack marginTop={0.5} />
      <Text>{`${intl.formatMessage(
        {
          defaultMessage:
            "{numberOfHandicaps, plural, =0 {Pas d'accessibilité} =1 {Accessibilité adaptée au handicap } other {Accessibilité adaptée aux handicaps }}",
        },
        { numberOfHandicaps: handicapList.length }
      )}${intl.formatList(
        handicapList.map((handicap) => {
          return intlFormatConstantByValue({
            intl,
            messages: HOTEL_HANDICAP_INTL_MESSAGES.byValue,
            preferredAttributes: ["label"],
            value: handicap,
          });
        })
      )}`}</Text>
    </>
  );
};

export default RoomHandicapList;
